var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0356 28C13.594 28 13.2207 27.6802 13.1138 27.2518C12.7729 25.8864 12.1204 24.4343 11.1562 22.8959C10.0139 21.0486 8.38541 19.3351 6.27084 17.7552C4.43169 16.3652 2.59253 15.4172 0.753393 14.9115C0.317807 14.7918 0 14.4056 0 13.9538C0 13.5109 0.305582 13.1291 0.731462 13.0075C2.53463 12.4927 4.27171 11.6568 5.94271 10.5C7.86285 9.1632 9.46701 7.55902 10.7552 5.6875C11.8948 4.02031 12.6771 2.37143 13.1021 0.74089C13.2134 0.313733 13.5895 0 14.0309 0C14.4773 0 14.856 0.320681 14.9646 0.753662C15.2099 1.73116 15.5932 2.73168 16.1146 3.75521C16.7709 5.0191 17.6093 6.23437 18.6302 7.40104C19.6753 8.5434 20.8421 9.57639 22.1302 10.5C23.8136 11.6932 25.5248 12.5316 27.2642 13.015C27.6909 13.1335 28 13.5134 28 13.9562C28 14.4057 27.6815 14.7888 27.2481 14.9076C26.1456 15.2099 25.0107 15.6974 23.8438 16.3698C22.434 17.1962 21.1215 18.1805 19.9062 19.3229C18.691 20.441 17.6945 21.6198 16.9166 22.8593C15.9506 24.401 15.2974 25.8643 14.9572 27.2495C14.8516 27.6791 14.4778 28 14.0356 28Z",
    fill: "white",
    fillOpacity: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar6);
export default __webpack_public_path__ + "static/media/star_6.7a160c6bb9db6cbb30578cb92a433e3a.svg";
export { ForwardRef as ReactComponent };